<template>
  <div>
    <v-row no-gutters justify="center">
      <v-col cols="auto" style="position: relative;">
        <div style="position: absolute; top: -10px;">100%</div>
        <div style="position: absolute; top: 57px;">80%</div>
        <div style="position: absolute; top: 127px;">60%</div>
        <div style="position: absolute; top: 197px;">40%</div>
        <div style="position: absolute; top: 267px;">20%</div>
        <div style="position: absolute; top: 337px;">0%</div>
      </v-col>
      <v-col cols="auto" style="transform: translateX(35px); max-width: 400px;">
        <v-img src="@/assets/images/ceo_info_area_chart.png"
               :height="350"
               style="opacity: 0.9;"
               contain
               class="ml-3"
        ></v-img>
        <v-row no-gutters justify="space-between" style="font-size: 12px;">
          <v-col cols="auto">1970</v-col>
          <v-col cols="auto" style="transform: translateX(4px);">1980</v-col>
          <v-col cols="auto" style="transform: translateX(5px);">1990</v-col>
          <v-col cols="auto" style="transform: translateX(6px);">2000</v-col>
          <v-col cols="auto" style="transform: translateX(7px);">2010</v-col>
          <v-col cols="auto" style="transform: translateX(8px);">2020</v-col>
          <v-col cols="auto" style="transform: translateX(9px);">2030</v-col>
          <v-col cols="auto" style="transform: translateX(10px);">2040</v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="mt-3">
      <div class="white--text text-center">Share of total power generation (global)</div>
      <div class="white--text text-center">Source: 2018 BP Energy Outlook</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareOfTotalPower"
}
</script>

<style scoped>

</style>